module.exports = __webpack_public_path__ + "static/img/mark9.9391a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark9.png
// module id = dJHF
// module chunks = 0